import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { WebApiService } from '../service/web-api.service';
import { environment } from '../../environments/environment';

@Injectable()
export class SelectResourceService {

  constructor(private webApiServece: WebApiService) { }

  /**
   * リソース一覧情報、isMulti取得
   */
  execResourceInfoList() {
　　const requestParam = {};
　  return this.webApiServece.callAjaxPost(environment.apiServerBaseUrl + '/authorization/resource-info-list', requestParam)
     .map(cfResponse => {
        return cfResponse.data;
      })
      .catch(error => {
        return Observable.throw(error);
      });
  }

  /**
   * リソース選択
   * @param result 選択(select), キャンセル(cancel)
   * @param resourceId 選択されたリソースID
   */
  execSelectResource(result: string, resourceId: string) {
    const requestParam = { 'result': result, 'resource_id': resourceId};
　  return this.webApiServece.callAjaxPost(environment.apiServerBaseUrl + '/authorization/select-resource', requestParam)
     .map(cfResponse => {
        const data = cfResponse.data;
        // NGの場合はメッセージ、正常の場合はnullを返却
        if (! data.result) {
          return data.messages;
        }
        return null;
      })
      .catch(error => {
        return Observable.throw(error);
      });
  }

}
